"use strict";
var import_fs = require("fs");
var import_os = require("os");
var import_path = require("path");
var import_vitest = require("vitest");
var import_workerdDevPlugin = require("./workerdDevPlugin");
var testDir;
(0, import_vitest.afterEach)(function() {
  if (testDir) {
    (0, import_fs.rmSync)(testDir, {
      recursive: true,
      force: true
    });
    testDir = void 0;
  }
});
(0, import_vitest.describe)("generateWorkerdDevEntryModule", function() {
  (0, import_vitest.it)("emits createWorkerHandler wiring and lazy imports for pages and api routes", function() {
    testDir = (0, import_fs.mkdtempSync)((0, import_path.join)((0, import_os.tmpdir)(), "one-workerd-entry-"));
    var appDir = (0, import_path.join)(testDir, "app");
    (0, import_fs.mkdirSync)((0, import_path.join)(appDir, "api"), {
      recursive: true
    });
    (0, import_fs.writeFileSync)((0, import_path.join)(appDir, "ssr-page+ssr.tsx"), "export default function Page() { return null }\n");
    (0, import_fs.writeFileSync)((0, import_path.join)(appDir, "api", "hello+api.ts"), 'export function GET() { return new Response("ok") }\n');
    var code = (0, import_workerdDevPlugin.generateWorkerdDevEntryModule)({
      root: testDir,
      options: {
        web: {
          defaultRenderMode: "ssr"
        }
      },
      routerRoot: "app",
      routePaths: [
        "./ssr-page+ssr.tsx",
        "./api/hello+api.ts"
      ],
      preloads: [
        "/@vite/client"
      ]
    });
    (0, import_vitest.expect)(code).toContain("from 'one/serve-worker'");
    (0, import_vitest.expect)(code).toContain("disableModuleCache: true");
    (0, import_vitest.expect)(code).toContain('serverEntry: () => import("virtual:one-entry")');
    (0, import_vitest.expect)(code).toContain("/api/hello");
    (0, import_vitest.expect)(code).toContain("ssr-page+ssr.tsx");
  });
});
//# sourceMappingURL=workerdDevPlugin.test.js.map
